import React from 'react';
import { map, get, isEmpty, isUndefined, head } from 'lodash';
import classnames from 'classnames';

// local Dependencies
import { getLabel } from 'utils/getLabel';
import { Typeahead } from 'modules/typeahead';
import { DATA_TYPES } from 'constants/common';
import { checkbox as CheckBox } from 'ui/views/generic/checkbox';
import { Icon } from 'modules/icon-bank';
import { useState } from 'react';
import { title } from 'eslint-friendly-formatter/process';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { addEditAllergies as AddEditAllergies } from 'ui/views/widgets/addEditAllergies';
 *
 * // render
 * <AddEditAllergies propName='propValue'/>
 */

// section 1 : Search common allergies
const SearchAndAddAllergies = (props) => {

    // get the module prop values
    const { showTitleIcon = false, classSelect, titleClassName = null, previouslySelectedAllergies = [], currentSelectedAllergies = [], isAllergiesNotAtVerified, isHealthConditionsNotAtVerified, isNoKnownDrugAllergies, isNoKnownHealthConditions, isNoDataSelected, isNotVerifiedDataSelected } = props;

    const _titleClassName = classnames('ui-add-edit-allergies__search-allergies__title ui-add-label', titleClassName);

    // extracting fields
    const searchAndAddAllergiesFields = props.detail.fields;
    const combinedList = [...previouslySelectedAllergies, ...currentSelectedAllergies];
    const ignoreOptions = map(combinedList, allergy => {
        return (allergy.id || allergy.value);
    });

    return (
        <div className='ui-add-edit-allergies__search-allergies'>

            {/* title */}
            <div className={_titleClassName}>

                {/*  show icon */}
                {showTitleIcon && (

                    <Icon id={'hospital'} />

                )}
                {getLabel(props.detail.title)}
            </div>


            {/* Search Bar */}
            {
                map(searchAndAddAllergiesFields, ( field ) => {
                    return (
                        <div onClick={() => {
                            props.clearCheckboxSelectionForAllergies( props?.detail?.title?.refId === 'displayTextAllergies' || props?.detail?.title?.refId === 'displayTextSearchAndAddAllergies' )
                        }}>
                            <Typeahead
                                key={field.name}
                                className='field-value-search__typeahead'
                                size='large'
                                url={get(field, 'url')}
                                placeholder={field.placeholder}
                                type={DATA_TYPES.MULTI_SELECT}
                                ignoreOptions={ignoreOptions}
                                ignoreQueryChangeOnSelect={true}
                                onChange={({ selected, options }) => {
                                    props.onAllergySelection({ selected, options }); // update selected value
                                }}
                                selectionCriteria={props.selectionCriteria}
                                isBlankDivRquied = {props.isBlankDivRquied}
                            />
                        </div>
                    );
                })
            }

            {/* Picked Allergies from the common allergies */}
            <div className='ui-add-edit-allergies__search-allergies__selected'>
                {
                    map((currentSelectedAllergies), field => {

                        return (
                            <div key={field.name} className='ui-add-edit-allergies__search-allergies__selected__allergy'>
                                <div className='ui-add-edit-allergies__search-allergies__selected__allergy__name'>
                                    {getLabel(field.altTitle)}
                                </div>
                                <div className='ui-add-edit-allergies__search-allergies__selected__allergy__checkbox'>
                                    <CheckBox
                                        size='xs'
                                        value={field.selected}
                                        onClick={() =>
                                            props.updateCurrentSelectedList({ item: field })
                                        }
                                    />
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
};

// set display name
SearchAndAddAllergies.displayName = 'addEditAllergies.searchAndAddAllergies';

/**-------------------- */

// section 2 : member allergies
const MemberAllergies = (props) => {

    return (
        <div className='ui-add-edit-allergies__member-allergies'>
            {
                map((props.data), field => {

                    return (
                        <div key={field.id} className='ui-add-edit-allergies__member-allergies__allergy'>
                            <div className='ui-add-edit-allergies__member-allergies__allergy__name'>
                                {field.name}
                            </div>
                            <div className='ui-add-edit-allergies__member-allergies__allergy__checkbox'>
                                <CheckBox
                                    size='xs'
                                    value={field.selected}
                                    onClick={() => props.updatePreSelectedList({ item: field })}
                                />
                            </div>
                        </div>
                    );
                })
            }
        </div>
    );
};

// set display name
MemberAllergies.displayName = 'addEditAllergies.memberAllergies';

/**-------------------- */

const NoDataView = (props) => {

    //   const noData = head( props.fields );
    const noData = get(props, 'fields', []);
    return (
        <div className='ui-add-allergy'>
            {'AllergiesCondition' === props.titlehealth ?
                <><div className='ui-add-edit-allergies-no-data ui-add-editcheck'
                    onClick={() => props.onNotVerifiedDataSelection(props.titlehealth)}
                >
                    <CheckBox
                        size='s'
                        value={props.isAllergiesNotAtVerified}
                        // disabled= { props.isNoKnownDrugAllergies }
                        id='NVA'

                    />
                    <div className='ui-add-edit-allergies-no-data__label'>
                        {noData[1] !== undefined ? getLabel(noData[1].title) : null}
                    </div>
                </div><div className='ui-add-edit-allergies-no-data ui-add-editcheck'
                    onClick={() => props.onNoDataSelection(props.titlehealth)} >
                        <CheckBox
                            size='s'
                            value={props.isNoKnownDrugAllergies}
                            // disabled= { props.isAllergiesNotAtVerified }
                            id='NKA'

                        />
                        <div className='ui-add-edit-allergies-no-data__label'>
                            {getLabel(noData[0].title)}
                        </div>
                    </div></> :
                <><div className='ui-add-edit-allergies-no-data ui-add-editcheck'
                    onClick={() => props.onNoDataSelection(props.titlehealth)} >
                    <CheckBox
                        size='s'
                        value={props.isNoKnownHealthConditions}
                        //  disabled= { props.isHealthConditionsNotAtVerified }
                        id='NKA'

                    />
                    <div className='ui-add-edit-allergies-no-data__label'>
                        {getLabel(noData[0].title)}
                    </div>
                </div></>

            }
        </div>

    );
};

/**-------------------- */

export const addEditAllergies = (props) => {
    const { noDataConfig, titlehealth, className, isNoDataSelected = false, isNotVerifiedDataSelected, isAllergiesNotAtVerified, isHealthConditionsNotAtVerified, isNoKnownDrugAllergies, isNoKnownHealthConditions } = props;

    const _className = classnames('ui-add-edit-allergies', className);

    const [disableAllergyCheckbox, setDisableAllergyCheckbox] = useState(isAllergiesNotAtVerified)


    const classSelect = titlehealth === 'HealthCondition' ?
    (isHealthConditionsNotAtVerified || isNoKnownHealthConditions)
    : (isAllergiesNotAtVerified ||  isNoKnownDrugAllergies) ;
    let isVisibleHealth = null;
    let isVisibleAllergies = null;
    if (titlehealth === 'HealthCondition'){
        isVisibleHealth = props.healthVisibility.others
        isVisibleAllergies = false
    } else if (titlehealth === 'AllergiesCondition'){
        isVisibleAllergies = props.allergiesVisibility.others
        isVisibleHealth = false
    }

    return (
        <div className={_className}>
            {<div>
                {!isUndefined(noDataConfig) && 'HealthCondition' !== props.titlehealth && !isEmpty(noDataConfig) && (

                    <NoDataView
                        {...noDataConfig}
                        onNoDataSelection={props.onNoDataSelection}
                        isNoDataSelected={isNoDataSelected}
                        isNotVerifiedDataSelected={isNotVerifiedDataSelected}
                        onNotVerifiedDataSelection={props.onNotVerifiedDataSelection}
                        isAllergiesNotAtVerified={props.isAllergiesNotAtVerified}
                        isHealthConditionsNotAtVerified={props.isHealthConditionsNotAtVerified}
                        isNoKnownDrugAllergies={props.isNoKnownDrugAllergies}
                        isNoKnownHealthConditions={props.isNoKnownHealthConditions}
                        titlehealth={props.titlehealth}
                        disableAllergyCheckbox={disableAllergyCheckbox}
                        disabled={disableAllergyCheckbox}
                    />

                )}
                {!isUndefined(noDataConfig) && 'HealthCondition' === props.titlehealth && !isEmpty(noDataConfig) && (

                    <NoDataView
                        {...noDataConfig}
                        onNoDataSelection={props.onNoDataSelection}
                        isNoDataSelected={isNoDataSelected}
                        isNotVerifiedDataSelected={isNotVerifiedDataSelected}
                        onNotVerifiedDataSelection={props.onNotVerifiedDataSelection}
                        isAllergiesNotAtVerified={props.isAllergiesNotAtVerified}
                        isHealthConditionsNotAtVerified={props.isHealthConditionsNotAtVerified}
                        isNoKnownDrugAllergies={props.isNoKnownDrugAllergies}
                        isNoKnownHealthConditions={props.isNoKnownHealthConditions}
                        titlehealth={props.titlehealth}

                    />

                )}


                {/* { ! isUndefined( noDataConfig ) && !isEmpty( noDataConfig ) && (

<NoDataView
    { ...noDataConfig }
    onNoDataSelection= { props.onNoDataSelection }
    isNoDataSelected={ isNoDataSelected }
/>


) } */}

            </div>}
            {/* search And Add Allergies section */}
            <SearchAndAddAllergies
                showTitleIcon={get(props, 'showTitleIcon', false)}
                titleClassName={props.titleClassName}
                currentSelectedAllergies={props.currentSelectedAllergies}
                detail={props.addEditMemberHealthConfig}
                updateCurrentSelectedList={props.updateCurrentSelectedList}
                previouslySelectedAllergies={props.previouslySelectedAllergies}
                isAllergiesNotAtVerified={props.isAllergiesNotAtVerified}
                isHealthConditionsNotAtVerified={props.isHealthConditionsNotAtVerified}
                isNoKnownDrugAllergies={props.isAllergiesNotAtVerified}
                isNoKnownHealthConditions={props.isAllergiesNotAtVerified}
                classSelect={classSelect}
                onAllergySelection={props.onAllergySelection} // if user check/unCheck from the selected options
                selectionCriteria={props.selectionCriteria}
                isNoDataSelected={isNoDataSelected}
                isNotVerifiedDataSelected={isNotVerifiedDataSelected}
                isBlankDivRquied = {props.isBlankDivRquied}
                clearCheckboxSelectionForAllergies={props.clearCheckboxSelectionForAllergies}

            />


            {/* display member Allergies */}
            {

                !isEmpty(props.previouslySelectedAllergies) ? (
                    <MemberAllergies
                        data={props.previouslySelectedAllergies}
                        updatePreSelectedList={props.updatePreSelectedList}
                    />
                ) : (null)
            }

            {/* Section 3 : Add notes */}
            
        {(isVisibleAllergies && titlehealth === "AllergiesCondition") &&<div className={`ui-add-edit-allergies__note_${titlehealth}`}>
            <textarea
                className={'ui-add-edit-allergies__note__textarea'}
                type='text'
                id={`textarea-${titlehealth}`}
                rows={4}
                placeholder={getLabel(props.notePlaceHolder)}
                value={props.note}
                onChange={(e) => props.onNoteUpdate(e)}
            />
        </div>}
        {(isVisibleHealth && titlehealth === "HealthCondition") &&<div className={`ui-add-edit-allergies__note_${titlehealth}`}>
            <textarea
                className={'ui-add-edit-allergies__note__textarea'}
                type='text'
                id={`textarea-${titlehealth}`}
                rows={4}
                placeholder={getLabel(props.notePlaceHolder)}
                value={props.note}
                onChange={(e) => props.onNoteUpdate(e)}
            />
        </div>}
        </div>
    );
};

// set display name
addEditAllergies.displayName = 'addEditAllergies';

// set default props
addEditAllergies.defaultProps = {};

// prop types
addEditAllergies.propTypes = {};
